<template>
  <q-page padding>
    <PageHeader>
      <template #title> Pedido de Compra: #{{ route.params.id }} </template>
    </PageHeader>

    <!-- Alerta de bloqueio de edição -->
    <q-banner
      v-if="edicaoBloqueada"
      class="bg-warning text-white q-mb-md"
      rounded
    >
      <template v-slot:avatar>
        <q-icon name="lock" color="white" />
      </template>
      <div class="text-weight-bold">Edição Bloqueada</div>
      <div class="text-caption">
        Este pedido possui um contrato vinculado ({{
          contratoVinculado.contractNumber
        }}) e não pode ser editado. Para realizar alterações, é necessário
        primeiro desvincular o contrato.
      </div>
    </q-banner>

    <div class="q-ml-md">
      <section class="column text-brand-5 text-weight-bold">
        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px"> Pedido Suprimentos:</span>

          <div class="q-ml-xs row items-center">
            <q-input
              style="width: 215px"
              dense
              v-model="suprimento"
              outlined
              label="Codigo Integração"
            />
          </div>
        </span>

        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Número Contrato</span>

          <div class="q-ml-xs row items-center">
            <q-btn
              v-if="!contratoVinculado || editandoContrato"
              dense
              outlined
              color="primary"
              icon="link"
              label="Vincular Contrato"
              style="width: 215px"
              @click="abrirModalContratos"
              :loading="carregandoContratos"
            />

            <div v-else class="row items-center" style="flex-grow: 1">
              <div class="row items-center">
                <q-icon
                  :name="getStatusIcon(contratoVinculado.status)"
                  :color="getStatusColor(contratoVinculado.status)"
                  size="16px"
                  class="q-mr-xs"
                />
                <span
                  class="text-caption text-weight-medium"
                  :class="getStatusClass(contratoVinculado.status)"
                >
                  {{ contratoVinculado.contractNumber }} -
                  {{ contratoVinculado.status }} -
                  {{ contratoVinculado.supplyName }}
                </span>
              </div>
              <q-btn
                flat
                dense
                icon="edit"
                color="primary"
                class="q-ml-xs"
                @click="editarContrato"
                size="sm"
              />
            </div>
          </div>
        </span>

        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Total da Ordem:</span>
          <span style="font-size: 12px" class="q-ml-sm text-brand-1">
            {{ dados.total_produtos ? formatPreco(dados.total_produtos) : "" }}
          </span>
        </span>
        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Urgência Definida:</span>
          <span style="font-size: 12px" class="q-ml-sm text-brand-1">
            <span>{{ dados?.tag?.nome ? dados.tag?.nome : "" }}</span>
          </span>
        </span>
        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Solicitante:</span>
          <span style="font-size: 12px" class="q-ml-sm text-brand-1">
            <span
              v-if="
                dados &&
                dados.products.length > 0 &&
                dados.products[0].necessidade_compra &&
                dados.products[0].necessidade_compra.solicitante
              "
            >
              {{ dados.products[0].necessidade_compra.solicitante.nome }}
            </span>
          </span>
        </span>

        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Unidade de Controle:</span>
          <span style="font-size: 12px" class="q-ml-sm text-brand-1">
            <span
              v-if="
                dados &&
                dados.products.length > 0 &&
                dados.products[0].necessidade_compra &&
                dados.products[0].necessidade_compra.centro_custo
              "
            >
              {{
                dados.products[0].necessidade_compra.centro_custo.codigo || ""
              }}
              <span
                v-if="dados.products[0].necessidade_compra.centro_custo.nome"
              >
                ({{ dados.products[0].necessidade_compra.centro_custo.nome }})
              </span>
            </span>
            <span v-else></span>
          </span>
        </span>

        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Criada Em:</span>
          <span style="font-size: 12px" class="q-ml-sm text-brand-1">
            <span>{{
              dados.created_at?.split(" ")[0].split("-").reverse().join("/")
            }}</span>
          </span>
        </span>

        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          <span style="min-width: 163px">Status Pedido:</span>
          <span style="font-size: 12px" class="q-ml-sm text-brand-1">
            <span>{{
              dados.aprovacao == "pendente"
                ? "Pendente"
                : dados.aprovacao == "aguardando"
                ? "Fluxo de Aprovação Iniciado"
                : dados.aprovacao == "aprovado"
                ? "Pedido Aprovado"
                : ""
            }}</span>
          </span>
        </span>

        <span
          style="font-size: 16px"
          class="q-mt-sm text-brand-5 text-weight-bold row items-center"
        >
          Este pedido foi gerado a partir da necessidade:
          <span
            v-if="
              dados &&
              dados.products.length != 0 &&
              dados.products[0].necessidade_compra
            "
            style="font-size: 12px"
            class="q-ml-sm text-brand-1"
            @click="rota(dados.products[0].necessidade_compra.uuid)"
          >
            <span>{{ dados.products[0]?.necessidade_compra?.numero }}</span>
          </span>
        </span>

        <div v-if="dados.aprovacao == 'pendente'" class="row col-2 q-mt-md">
          <q-btn
            @click="iniciarFluxo"
            class="q-mt-sm"
            no-caps
            icon="done"
            style="border-radius: 8px; background-color: #21324a; color: white"
            label="Iniciar Fluxo de Aprovação"
            :disable="!podeIniciarFluxo"
          />
        </div>
      </section>
    </div>

    <fluxo-aprovacao @atualizar="getDados" :id="id" :att="att" />
    <table-produtos-editar
      @atualizar="getDados"
      :att="att2"
      :edicaoBloqueada="edicaoBloqueada"
    />

    <produtos-table
      v-if="dados && dados.products.length == 0"
      :provider_id="dados.provider_id"
      @atualizar="getDados"
    />

    <ModalLateral
      :rightDrawerOpen="modalContratosOpen"
      :nomeModal="'Vincular Contrato'"
      @fecharModal="fecharModalContratos"
    >
      <template v-slot:conteudo-modal>
        <div class="q-mb-md">
          <div class="texto-titulo-input">Selecionar Contrato</div>
          <q-select
            v-model="contratoSelecionado"
            :options="contratosOptions"
            outlined
            dense
            use-input
            hide-selected
            fill-input
            input-debounce="300"
            :loading="carregandoContratos"
            option-label="contractNumber"
            option-value="id"
            label="Digite para buscar contratos"
            class="input-new-design"
            @filter="filtrarContratos"
            @input-value="setModel"
            clearable
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-grey">
                  Nenhum contrato encontrado
                </q-item-section>
              </q-item>
            </template>

            <template v-slot:option="scope">
              <q-item v-bind="scope.itemProps">
                <q-item-section>
                  <q-item-label class="text-weight-bold text-brand-1">
                    {{ scope.opt.contractNumber }}
                  </q-item-label>
                  <q-item-label caption class="row items-center q-mt-xs">
                    <q-icon
                      :name="getStatusIcon(scope.opt.status)"
                      :color="getStatusColor(scope.opt.status)"
                      size="16px"
                      class="q-mr-xs"
                    />
                    <span :class="getStatusClass(scope.opt.status)">
                      {{ scope.opt.status }}
                    </span>
                    <span class="q-mx-xs">•</span>
                    <span>{{
                      scope.opt.supplyName || "Tipo não informado"
                    }}</span>
                  </q-item-label>
                  <q-item-label caption class="q-mt-xs">
                    <strong>Fornecedor:</strong>
                    {{
                      scope.opt.provider?.fantasyName ||
                      scope.opt.provider?.businessName ||
                      "Não informado"
                    }}
                  </q-item-label>
                  <q-item-label caption class="q-mt-xs">
                    <strong>Vigência:</strong>
                    {{ formatDate(scope.opt.startDate) }} até
                    {{ formatDate(scope.opt.endDate) }}
                  </q-item-label>
                </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>

        <div v-if="contratoSelecionado" class="q-mb-md">
          <div class="texto-titulo-input q-mb-sm">Contrato Selecionado</div>
          <q-card class="contrato-preview">
            <q-card-section class="q-pa-md">
              <div class="row items-center q-mb-xs">
                <span
                  class="text-weight-bold text-brand-1"
                  style="font-size: 16px"
                >
                  {{ contratoSelecionado.contractNumber }}
                </span>
                <q-space />
                <q-icon
                  :name="getStatusIcon(contratoSelecionado.status)"
                  :color="getStatusColor(contratoSelecionado.status)"
                  size="20px"
                />
              </div>

              <div class="text-caption text-grey-6 q-mb-xs">
                <strong>Status:</strong>
                <span :class="getStatusClass(contratoSelecionado.status)">{{
                  contratoSelecionado.status
                }}</span>
              </div>

              <div class="text-caption text-grey-6 q-mb-xs">
                <strong>Tipo de Fornecimento:</strong>
                {{ contratoSelecionado.supplyName || "Não informado" }}
              </div>

              <div class="text-caption text-grey-6 q-mb-xs">
                <strong>Fornecedor:</strong>
                {{
                  contratoSelecionado.provider?.fantasyName ||
                  contratoSelecionado.provider?.businessName ||
                  "Não informado"
                }}
              </div>

              <div class="text-caption text-grey-6">
                <strong>Vigência:</strong>
                {{ formatDate(contratoSelecionado.startDate) }} até
                {{ formatDate(contratoSelecionado.endDate) }}
              </div>
            </q-card-section>
          </q-card>
        </div>
      </template>

      <template v-slot:botao-modal>
        <div class="row q-gutter-sm full-width">
          <q-btn
            flat
            label="Cancelar"
            color="grey-7"
            @click="fecharModalContratos"
            class="col"
          />
          <q-btn
            label="Vincular Contrato"
            color="positive"
            icon="link"
            @click="confirmarVinculacao"
            :disable="!contratoSelecionado"
            class="col"
          />
        </div>
      </template>
    </ModalLateral>
  </q-page>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import FluxoAprovacao from "../components/FluxoAprovacao.vue";
import TableProdutosEditar from "../components/TableProdutosEditar.vue";
import ProdutosTable from "../components/ProdutosTable.vue";
import { watchDebounced } from "@vueuse/core";
import ModalLateral from "../../../../components/ModalLateral.vue";
import PageHeader from "../../../../components/PageHeader.vue";

// funçao para formatar preço no padrao brasileiro (sempre 2 casas decimais)
const formatPreco = (value) => {
  if (!value && value !== 0) return "R$ 0,00";
  const num = Number(value);
  if (isNaN(num)) return "R$ 0,00";

  return `R$ ${num.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export default {
  components: {
    FluxoAprovacao,
    TableProdutosEditar,
    ProdutosTable,
    ModalLateral,
    PageHeader,
  },
  setup() {
    const route = useRoute();
    const att = ref(0);
    const att2 = ref(0);
    const store = useStore();
    const $q = useQuasar();
    const router = useRouter();
    const id = route.params.id;
    const dados = ref("");
    const suprimento = ref("");

    const contratoVinculado = ref(null);
    const contratoSelecionado = ref(null);
    const contratosOptions = ref([]);
    const carregandoContratos = ref(false);
    const editandoContrato = ref(false);
    const modalContratosOpen = ref(false);
    const filtroContrato = ref("");

    const isAccionaTenant = computed(() => {
      const cliente = store.state.autenticacao.cliente;
      if (!cliente || !Array.isArray(cliente)) return false;

      const clienteId = cliente[0]?.toLowerCase() || "";
      return (
        clienteId.includes("acciona") || clienteId.includes("staging-acciona")
      );
    });

    const podeIniciarFluxo = computed(() => {
      if (!isAccionaTenant.value) {
        // para outros clientes, sempre pode iniciar
        return true;
      }

      // para acciona e staging acciona, precisa ter pelo menos um dos campos preenchidos
      const temSuprimento = suprimento.value && suprimento.value.trim() !== "";
      const temContrato = contratoVinculado.value !== null;

      return temSuprimento || temContrato;
    });

    const edicaoBloqueada = computed(() => {
      return isAccionaTenant.value && contratoVinculado.value !== null;
    });

    const getDados = async () => {
      try {
        const response = await store.dispatch("compras/pedidoEspecifico", {
          id: id,
        });

        att.value++;
        att2.value++;
        dados.value = response.data.message;
        suprimento.value = response.data.message.cNumero;

        if (response.data.message.contract) {
          const contratoNumero = response.data.message.contract;

          const supplyNameAtual = contratoVinculado.value?.supplyName;

          contratoVinculado.value = {
            id: contratoNumero.id,
            contractNumber:
              contratoNumero.number || contratoNumero.contractNumber,
            status: contratoNumero.status,
            supplyName:
              contratoNumero.supply?.name ||
              contratoNumero.supplyName ||
              contratoNumero.supply_name ||
              contratoNumero.supply?.tipo ||
              supplyNameAtual,
            provider: contratoNumero.provider,
            startDate: contratoNumero.startDate || contratoNumero.start_date,
            endDate: contratoNumero.endDate || contratoNumero.end_date,
          };

          if (!contratoVinculado.value.supplyName) {
            await buscarDadosCompletoContrato(contratoNumero.id);
          }
        } else {
          contratoVinculado.value = null;
        }
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const buscarDadosCompletoContrato = async (contratoId) => {
      try {
        const providerId = dados.value?.provider_id;
        if (!providerId) return;

        const response = await store.dispatch("gdcStore/getContratos", {
          providerId: providerId,
          page: 1,
          perPage: 100,
        });

        const contratoCompleto = response.data.result.data?.find(
          (c) => c.id === contratoId
        );

        if (contratoCompleto && contratoCompleto.supplyName) {
          contratoVinculado.value.supplyName = contratoCompleto.supplyName;
        }
      } catch (error) {
        console.error("Erro ao buscar dados completos do contrato:", error);
      }
    };

    onMounted(getDados);

    const setSuprimento = async () => {
      try {
        await store.dispatch("compras/setSuprimento", {
          cNumero: suprimento.value,
          purchase_id: id,
        });

        $q.notify({
          message: "Atualizado com successo",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro a o atualizar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const iniciarFluxo = async () => {
      try {
        store.dispatch("compras/solicitarAprovacao", {
          purchase_id: id,
        });

        $q.notify({
          message: "Aprovação solicitada",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro a o solicitar aprovação",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const rota = async (id) => {
      router.push({
        name: "compras-detalhe",
        params: { id: id },
      });
    };

    watchDebounced(
      () => suprimento.value,
      () => {
        if (suprimento.value == dados.value.cNumero) {
          return;
        }
        setSuprimento();
      },
      { debounce: 800 }
    );

    const abrirModalContratos = () => {
      modalContratosOpen.value = true;
      contratoSelecionado.value = null;
      contratosOptions.value = [];
    };

    const fecharModalContratos = () => {
      modalContratosOpen.value = false;
      contratoSelecionado.value = null;
      contratosOptions.value = [];
    };

    const filtrarContratos = async (val, update) => {
      update(async () => {
        try {
          carregandoContratos.value = true;

          // Buscar contratos do fornecedor do pedido
          const providerId = dados.value?.provider_id;
          if (!providerId) {
            contratosOptions.value = [];
            return;
          }

          const response = await store.dispatch("gdcStore/getContratos", {
            providerId: providerId,
            contractNumber: val,
            page: 1,
            perPage: 20,
          });

          contratosOptions.value = response.data.result.data || [];
        } catch (error) {
          console.error("Erro ao buscar contratos:", error);
          contratosOptions.value = [];
        } finally {
          carregandoContratos.value = false;
        }
      });
    };

    const setModel = () => {};

    const selecionarContrato = (contrato) => {
      contratoSelecionado.value = contrato;
    };

    const confirmarVinculacao = () => {
      if (!contratoSelecionado.value) return;

      $q.dialog({
        title: "Confirmar Vinculação",
        message: `Tem certeza que deseja vincular o contrato ${contratoSelecionado.value.contractNumber} ao pedido de compras?`,
        cancel: true,
        persistent: true,
      }).onOk(() => {
        vincularContrato(contratoSelecionado.value.id);
      });
    };

    const vincularContrato = async (contratoId) => {
      try {
        await store.dispatch("gdcStore/vincularPedidoContrato", {
          contratoId: contratoId,
          pedidoId: id,
        });

        // encontrar o contrato selecionado e atualizar
        const contrato = contratosOptions.value.find(
          (c) => c.id === contratoId
        );

        if (contrato) {
          contratoVinculado.value = contrato;
        }

        editandoContrato.value = false;
        fecharModalContratos();

        $q.notify({
          message: "Contrato vinculado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });

        // atualizar apenas os dados do pedido sem sobrescrever o contrato
        att.value++;
        att2.value++;
      } catch (error) {
        console.error("Erro completo ao vincular contrato:", error);

        let errorMessage = "Erro ao vincular contrato";

        try {
          if (error.response?.data?.message) {
            const message = error.response.data.message;

            if (
              typeof message === "string" &&
              (message.startsWith("{") || message.startsWith("["))
            ) {
              const parsedMessage = JSON.parse(message);

              if (parsedMessage.status && Array.isArray(parsedMessage.status)) {
                errorMessage = parsedMessage.status[0];
              } else if (Array.isArray(parsedMessage)) {
                errorMessage = parsedMessage[0];
              } else if (typeof parsedMessage === "object") {
                const keys = Object.keys(parsedMessage);
                for (const key of keys) {
                  if (
                    Array.isArray(parsedMessage[key]) &&
                    parsedMessage[key].length > 0
                  ) {
                    errorMessage = parsedMessage[key][0];
                    break;
                  }
                }
              }
            } else {
              errorMessage = message;
            }
          } else if (error.response?.data?.errors) {
            const errors = error.response.data.errors;
            if (typeof errors === "object") {
              const firstKey = Object.keys(errors)[0];
              if (firstKey) {
                const firstError = errors[firstKey];
                errorMessage = Array.isArray(firstError)
                  ? firstError[0]
                  : firstError;
              }
            }
          } else if (error.response?.data?.status) {
            let statusMessage = error.response.data.status;
            if (Array.isArray(statusMessage)) {
              errorMessage = statusMessage[0];
            } else {
              errorMessage = statusMessage;
            }
          } else if (error.message) {
            errorMessage = error.message;
          }
        } catch (parseError) {
          console.error("Erro ao fazer parse da mensagem de erro:", parseError);
          errorMessage =
            error.response?.data?.message ||
            error.message ||
            "Erro ao vincular contrato";
        }

        $q.notify({
          message: errorMessage,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      }
    };

    const editarContrato = () => {
      editandoContrato.value = true;
      contratoSelecionado.value = null;

      // Confirmar remoção do contrato
      $q.dialog({
        title: "Desvincular Contrato",
        message: "Deseja desvincular o contrato atual do pedido?",
        cancel: {
          label: "Cancelar",
          color: "grey-7",
        },
        ok: {
          label: "Desvincular",
          color: "negative",
        },
        persistent: true,
      })
        .onOk(() => {
          desvincularContrato();
        })
        .onCancel(() => {
          editandoContrato.value = false;
        });
    };

    const desvincularContrato = async () => {
      try {
        await store.dispatch("gdcStore/desvincularPedidoCompra", {
          contratoId: contratoVinculado.value.id,
          pedidoId: id,
        });

        contratoVinculado.value = null;
        editandoContrato.value = false;

        $q.notify({
          message: "Contrato desvinculado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.error("Erro ao desvincular contrato:", error);
        $q.notify({
          message: "Erro ao desvincular contrato",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        editandoContrato.value = false;
      }
    };

    const getStatusIcon = (status) => {
      return status === "VIGENTE" ? "check_circle" : "cancel";
    };

    const getStatusColor = (status) => {
      return status === "VIGENTE" ? "positive" : "negative";
    };

    const getStatusClass = (status) => {
      return status === "VIGENTE" ? "text-positive" : "text-negative";
    };

    const formatDate = (dateString) => {
      if (!dateString) return "Não informado";
      try {
        return new Date(dateString).toLocaleDateString("pt-BR");
      } catch {
        return dateString;
      }
    };

    return {
      dados,
      id,
      getDados,
      suprimento,
      iniciarFluxo,
      rota,
      att,
      route,
      att2,

      // Contratos
      contratoVinculado,
      contratoSelecionado,
      contratosOptions,
      carregandoContratos,
      editandoContrato,

      modalContratosOpen,
      filtroContrato,
      abrirModalContratos,
      fecharModalContratos,
      filtrarContratos,
      setModel,
      selecionarContrato,
      confirmarVinculacao,
      vincularContrato,
      editarContrato,
      getStatusIcon,
      getStatusColor,
      getStatusClass,
      formatDate,

      isAccionaTenant,
      podeIniciarFluxo,
      edicaoBloqueada,
      formatPreco,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.align {
  align-items: center;
}

.cursor {
  cursor: pointer;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}

.contrato-card {
  border: 1px solid #e0e0e0;
  transition: all 0.2s;
}

.contrato-card:hover {
  border-color: #1976d2;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.15);
}

.contrato-selected {
  border-color: #1976d2;
  background-color: #e3f2fd;
}

.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.texto-titulo-input {
  font-size: 13px;
  margin-bottom: 6px;
  font-weight: 600;
  color: #304f78;
}
</style>
